import { render } from "./ButtonBlack.vue?vue&type=template&id=1c4f885c&scoped=true"
import script from "./ButtonBlack.vue?vue&type=script&lang=js"
export * from "./ButtonBlack.vue?vue&type=script&lang=js"

import "./ButtonBlack.vue?vue&type=style&index=0&id=1c4f885c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c4f885c"

export default script